import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

import "../../css/template/elements.css"
import "../../css/blocks/schedule.css"

export default class extends Controller {

    connect() {

        $.ajax({
            type: "get",
            url: 'https://api.actualoptic.kz:8443/cabinet/doctor/'+ usertoken,
            contentType: "application/json",
            acync: false,
            success: function(data){
                $('#doctorName').text(data.doctor_name);

                //понедельник
                if (data.work_schedule.monday[0] === 'hour-empty' || data.work_schedule.monday[1] === 'hour-empty'){
                    $('#scheduleMondayHours').html('<span class="schedule__hours--empty">Выходной</span>')
                } else {
                    $('#scheduleMondayHours').text(data.work_schedule.monday[0] + ' - ' + data.work_schedule.monday[1])
                }

                //вторник
                if (data.work_schedule.tuesday[0] === 'hour-empty' || data.work_schedule.tuesday[1] === 'hour-empty'){
                    $('#scheduleTuesdayHours').html('<span class="schedule__hours--empty">Выходной</span>')
                } else {
                    $('#scheduleTuesdayHours').text(data.work_schedule.tuesday[0] + ' - ' + data.work_schedule.tuesday[1])
                }

                //среда
                if (data.work_schedule.wednesday[0] === 'hour-empty' || data.work_schedule.wednesday[1] === 'hour-empty'){
                    $('#scheduleWednesdayHours').html('<span class="schedule__hours--empty">Выходной</span>')
                } else {
                    $('#scheduleWednesdayHours').text(data.work_schedule.wednesday[0] + ' - ' + data.work_schedule.wednesday[1])
                }

                //четверг
                if (data.work_schedule.thursday[0] === 'hour-empty' || data.work_schedule.thursday[1] === 'hour-empty'){
                    $('#scheduleThursdayHours').html('<span class="schedule__hours--empty">Выходной</span>')
                } else {
                    $('#scheduleThursdayHours').text(data.work_schedule.thursday[0] + ' - ' + data.work_schedule.thursday[1])
                }

                //пятница
                if (data.work_schedule.friday[0] === 'hour-empty' || data.work_schedule.friday[1] === 'hour-empty'){
                    $('#scheduleFridayHours').html('<span class="schedule__hours--empty">Выходной</span>')
                } else {
                    $('#scheduleFridayHours').text(data.work_schedule.friday[0] + ' - ' + data.work_schedule.friday[1])
                }

                //суббота
                if (data.work_schedule.saturday[0] === 'hour-empty' || data.work_schedule.saturday[1] === 'hour-empty'){
                    $('#scheduleSaturdayHours').html('<span class="schedule__hours--empty">Выходной</span>')
                } else {
                    $('#scheduleSaturdayHours').text(data.work_schedule.saturday[0] + ' - ' + data.work_schedule.saturday[1])
                }

                //воскресенье
                if (data.work_schedule.sunday[0] === 'hour-empty' || data.work_schedule.sunday[1] === 'hour-empty'){
                    $('#scheduleSundayHours').html('<span class="schedule__hours--empty">Выходной</span>')
                } else {
                    $('#scheduleSundayHours').text(data.work_schedule.sunday[0] + ' - ' + data.work_schedule.sunday[1])
                }


            },
            error(error){
                console.debug(error);
                //window.location.replace("404.html");
        }

        });
    }
}